import type {
	GoalAndInterventionDefinitionLibraryViewModel,
	GoalDefinitionViewModel,
	GoalViewModel,
	InterventionDefinitionViewModel,
	InterventionViewModel
} from '@generated';
import { getSuggestedInterventionDefinitions } from '~/libraries/interventions/suggested';

export type SuggestedGoal = {
	type: 'new' | 'existing';
	goalDefinition: GoalDefinitionViewModel;
	existingGoal?: GoalViewModel;
	suggestedInterventions: InterventionDefinitionViewModel[];
};

export function getSuggestedGoalsAndInterventionsForVisit(
	visitFindings: string[],
	goalAndInterventionDefinitionLibrary: GoalAndInterventionDefinitionLibraryViewModel,
	existingGoals: GoalViewModel[],
	existingInterventions: InterventionViewModel[]
): SuggestedGoal[] {
	const suggestedInterventions = getSuggestedInterventionDefinitions(visitFindings, goalAndInterventionDefinitionLibrary.interventionDefinitions);

	const newSuggestedInterventions = suggestedInterventions.filter(x => !existingInterventions.some(i => i.interventionDefinitionId === x.id));
	if (newSuggestedInterventions.length === 0) {
		return [];
	}

	const suggestedGoalDefinitions = goalAndInterventionDefinitionLibrary.goalDefinitions.filter(x =>
		x.goalProcedures.some(y => newSuggestedInterventions.some(z => z.procedureConceptId === y.procedureConceptId))
	);

	const existingGoalDefinitionIds = existingGoals.map(x => x.goalDefinitionId);

	const existingSuggestedGoals = existingGoals
		.filter(x => suggestedGoalDefinitions.some(y => y.id === x.goalDefinitionId))
		.map(x => ({
			type: 'existing' as const,
			goalDefinition: suggestedGoalDefinitions.find(y => y.id === x.goalDefinitionId)!,
			existingGoal: x,
			suggestedInterventions: newSuggestedInterventions.filter(y =>
				x.goalDefinition!.goalProcedures.some(z => z.procedureConceptId === y.procedureConceptId)
			)
		}));

	const existingInterventionDefinitionIds = existingInterventions.map(x => x.interventionDefinitionId);

	const newSuggestedGoals = suggestedGoalDefinitions
		.filter(x => !existingGoalDefinitionIds.includes(x.id))
		.map(x => ({
			type: 'new' as const,
			goalDefinition: x,
			suggestedInterventions: newSuggestedInterventions.filter(
				y => !existingInterventionDefinitionIds.includes(y.id) && x.goalProcedures.some(z => z.procedureConceptId === y.procedureConceptId)
			)
		}));

	return [...existingSuggestedGoals, ...newSuggestedGoals];
}
